type EmailFilterEntry = { value: string; index: number };

export type SaveEmailFieldsPayload = {
    emails?: unknown;
    emailMainYn?: Array<boolean | number>;
};

export function buildSaveEmailFields(contactInfoPayload: SaveEmailFieldsPayload | null | undefined): {
    emails: string[];
    emailMainYn: boolean[];
    emailSyncYn: number[];
} {
    const rawEmails: string[] = Array.isArray(contactInfoPayload?.emails)
        ? contactInfoPayload.emails.map((e: unknown) => String(e ?? ''))
        : [''];

    const filteredEntries: EmailFilterEntry[] = [];
    for (let index = 0; index < rawEmails.length; index++) {
        const value = (rawEmails[index] || '').trim();
        if (value !== '') {
            filteredEntries.push({ value, index });
        }
    }

    const emails: string[] = [];
    const emailLimit = Math.min(filteredEntries.length, 2);
    for (let i = 0; i < emailLimit; i++) {
        emails.push(filteredEntries[i].value);
    }

    const mainYnSource = contactInfoPayload?.emailMainYn;
    const emailMainYn: boolean[] = [];
    for (let i = 0; i < emailLimit; i++) {
        const entry: EmailFilterEntry = filteredEntries[i];
        const flag: boolean | number = mainYnSource?.[entry.index] ?? entry.index === 0;
        emailMainYn.push(flag === true);
    }

    const emailSyncYn: number[] = [];
    for (let i = 0; i < emails.length; i++) {
        emailSyncYn.push(0);
    }
    return { emails, emailMainYn, emailSyncYn };
}
